import styled from 'styled-components';
import { getSemanticValue } from '@freenow/wave';
export const Body = styled.div `
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;

    background-color: ${getSemanticValue('background-page-default')};
    padding: 32px 24px;
`;
